// extracted by mini-css-extract-plugin
export default {"departments":"pJ-z","departmentHeading":"qJ-z","departmentSection":"rJ-z","departmentName":"sJ-z","departmentLink":"tJ-z","expandIcon":"uJ-z"};